import { selectIsLoggedIn } from 'containers/Login/loginSlice'
import { useHistory, useLocation } from 'react-router-dom'
import useTranslation from 'hooks/useTranslation'
import { LOCATION_STATES } from 'utils/constants'
import { useSelector } from 'react-redux'
import { isIos } from 'utils/mobile'
import './style.scss'

const type = process.env.REACT_APP_TYPE

const BottomBar = () => {
  const isLoggedIn = useSelector(selectIsLoggedIn)
  const { pathname, state } = useLocation()
  const isMenu = state === LOCATION_STATES.menu
  const ios = isIos()

  const { t } = useTranslation('menu')
  const { push } = useHistory()

  return (
    <div className={`bottomBar ${pathname === '/' || pathname === '/dashboard' ? 'gray' : ''} ${ios ? 'ios' : ''}`}>
      <div
        className={`bottomBar__button ${(pathname === '/dashboard' || (pathname === '/' && isLoggedIn)) && !isMenu ? 'active' : ''}`}
        onClick={() => {
          push('/dashboard')
        }}>
        <i className='icon icon--dashboard s24'></i>
        <span>{t('dashboard')}</span>
      </div>

      <div
        className={`bottomBar__button ${(pathname === '/home' || (pathname === '/' && !isLoggedIn)) && !isMenu ? 'active' : ''}`}
        onClick={() => {
          push('/home')
        }}>
        <i className='icon icon--plus s24'></i>
        <span>{t('rent')}</span>
      </div>

      <div
        className={`bottomBar__button ${pathname === '/account' && !isMenu ? 'active' : ''}`}
        onClick={() => {
          push('/account')
        }}>
        <i className='icon icon--user s24'></i>
        <span>{t('account')}</span>
      </div>

      <div
        className={`bottomBar__button ${isMenu ? 'active' : ''}`}
        onClick={() => {
          push(pathname, LOCATION_STATES.menu)
        }}>
        <i className='icon icon--more s24'></i>
        <span>{t(type === 'rze01' ? 'moreBasic' : 'more')}</span>
      </div>
    </div>
  )
}

export default BottomBar